export enum Modules {
    FACILITY = 'facility',
    COACH = 'coach',
    EVENT = 'event',
    MONTHLY_PROGRAM = 'monthly_program',
}